import { Link, NavLink } from 'react-router-dom'
import './index.scss'
import LogoSubtitle from '../../assets/images/logo_sub.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faEnvelope,
  faHome,
  faLaptop,
  faUser,
} from '@fortawesome/free-solid-svg-icons'
import {
  faGithub,
  faInstagram,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons'

const Sidebar = () => (
  <div className="nav-bar">
    <Link className="logo" to="/">
      <img className="sub-logo" src={LogoSubtitle} alt="saerom" />
    </Link>
    <nav>
      <NavLink exact="true" activeclassname="active" to="/">
        <FontAwesomeIcon icon={faHome} color="#9980fa" />
      </NavLink>
      <NavLink
        exact="true"
        activeclassname="active"
        className="about-link"
        to="/about"
      >
        <FontAwesomeIcon icon={faUser} color="#9980fa" />
      </NavLink>
      <NavLink
        exact="true"
        activeclassname="active"
        className="project-link"
        to="/project"
      >
        <FontAwesomeIcon icon={faLaptop} color="#9980fa" />
      </NavLink>
      <NavLink
        exact="true"
        activeclassname="active"
        className="contact-link"
        to="/contact"
      >
        <FontAwesomeIcon icon={faEnvelope} color="#9980fa" />
      </NavLink>
    </nav>
    <ul>
      <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.linkedin.com/in/saerom-hong-786665270/"
        >
          <FontAwesomeIcon icon={faLinkedin} color="#9980fa" />
        </a>
      </li>
      <li>
        <a target="_blank" rel="noreferrer" href="https://github.com/s1romy">
          <FontAwesomeIcon icon={faGithub} color="#9980fa" />
        </a>
      </li>
      <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.instagram.com/_siromi/"
        >
          <FontAwesomeIcon icon={faInstagram} color="#9980fa" />
        </a>
      </li>
    </ul>
  </div>
)

export default Sidebar
